import { c as _c } from "react/compiler-runtime";
import { ProjectCard } from "@components/common/project-card/project-card";
import { CardSkeleton } from "@components/common/skeleton-loading/card-skeleton";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { CARD_COLUMN_CONFIG, CARD_MIN_COLUMN_WIDTH } from "@components/virtualized/virtualized-grid-utils";
import { Box } from "@mui-wrapper";
/**
 * The projects tab listing all the active or archived projects (depending on the props) in the company
 */
export function ProjectsTiles(t0) {
  const $ = _c(11);
  const {
    isLoading,
    projects,
    companyId,
    loadMoreProjects,
    sortBy
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: "0.063rem"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== companyId || $[2] !== projects.length || $[3] !== sortBy) {
    t2 = project => <ProjectCard key={project.id} project={project} companyId={companyId} numberOfProjects={projects.length} sortBy={sortBy} />;
    $[1] = companyId;
    $[2] = projects.length;
    $[3] = sortBy;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoading || $[6] !== loadMoreProjects || $[7] !== projects || $[8] !== sortBy || $[9] !== t2) {
    t3 = <Box sx={t1}><VirtualizedGrid key={sortBy} items={projects} isLoading={isLoading} loadMoreItems={loadMoreProjects} columnConfig={CARD_COLUMN_CONFIG} minColumnWidth={CARD_MIN_COLUMN_WIDTH} renderSkeletonItem={_temp} renderItem={t2} /></Box>;
    $[5] = isLoading;
    $[6] = loadMoreProjects;
    $[7] = projects;
    $[8] = sortBy;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(i) {
  return <CardSkeleton key={`skeleton-project-${i}`} type="project" />;
}